export default __webpack_public_path__ + "static/register-c451dfc506874298d00b6b1da6378a52.png";